'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _wrapDisplayName = require('recompose/wrapDisplayName');

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _seedRandom = require('seed-random');

var _seedRandom2 = _interopRequireDefault(_seedRandom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TOKENS = /[xy]/g;

var uuid = function uuid(seed) {
  var random = seed === undefined ? Math.random : (0, _seedRandom2.default)(seed);

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(TOKENS, function (c) {
    var r = random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};

var counter = 0;

exports.default = function (Target) {
  var WithUniqueFormIdentifier = function (_Component) {
    _inherits(WithUniqueFormIdentifier, _Component);

    function WithUniqueFormIdentifier() {
      _classCallCheck(this, WithUniqueFormIdentifier);

      var _this = _possibleConstructorReturn(this, (WithUniqueFormIdentifier.__proto__ || Object.getPrototypeOf(WithUniqueFormIdentifier)).call(this));

      _this.uniqueFormIdentifier = (Target.displayName || Target.name) + '-' + uuid(counter++);
      return _this;
    }

    _createClass(WithUniqueFormIdentifier, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Target, _extends({ name: this.uniqueFormIdentifier }, this.props));
      }
    }]);

    return WithUniqueFormIdentifier;
  }(_react.Component);

  WithUniqueFormIdentifier.displayName = (0, _wrapDisplayName2.default)(Target, 'withUniqueFormIdentifier');

  return WithUniqueFormIdentifier;
};